import { createSignal } from '@verclam/pulsar';

/** `null` when no deletion is pending confirmation; otherwise the id of the staff member to confirm. */
const staffMemberToDeleteSignal = createSignal<number | null>(null);

export const setStaffMemberToDelete = (staffMemberId: number | null): void => {
	staffMemberToDeleteSignal.value = staffMemberId;
};

export default staffMemberToDeleteSignal;
